module.exports = __webpack_public_path__ + "media/newstyle/images/logo-submarino-54aae46ce4faa5beb5774ae6a80dd16b.png";